__turbopack_context__.v({
  "carousel": "PostsCarousel-module-scss-module__-KvK4a__carousel",
  "post-carousel": "PostsCarousel-module-scss-module__-KvK4a__post-carousel",
  "post-carousel-title": "PostsCarousel-module-scss-module__-KvK4a__post-carousel-title",
  "slide": "PostsCarousel-module-scss-module__-KvK4a__slide",
});
